module.exports = __webpack_public_path__ + "files/fbded805d8754c3786d0704ac4705b63.png";